<div class="upload-btn-wrapper">
  @if (label==='Add File') {
    <button
      pButton
      label="Add File"
      type="button"
      severity="secondary"
      icon="pi pi-plus"
      data-test-id="add-file-button"
    ></button>
  } @else {
    <button
      pButton
      label="Select File"
      type="button"
      severity="secondary"
    ></button>
  }
  <input
    type="file"
    name="myfile"
    [multiple]="multiple"
    [accept]="accept"
    (change)="onFileSelect($event)"
    />
  </div>
